export default {
  title: 'Maksa {{method}}',
  hint: 'Seuraavaksi vahvistat maksun pankkisi kanssa tai sovelluksessasi.',
  continue: 'Jatka',
  cancel: 'Peruuta maksu',
  unavailable: 'Tämä maksutapa ei ole juuri nyt käytettävissä. Valitse toinen.',
};
